import { Close } from '@mui/icons-material';
import { Dialog, DialogTitle, DialogActions, Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

type MemberImportCancelButtonProps = {
  callback: () => void;
  useConfirm?: boolean;
};

// Renderar en avbryt-knapp för Excel-importen
// Vid knapp-tryck, om useConfirm är true visas en dialog
// Fråga om användaren verkligen avser att avbryta
// Om användaren fortsätter, skicka callback till föräldern för hanteringen av avbruten import
export const MemberImportCancelButton = (props: MemberImportCancelButtonProps) => {
  const { callback, useConfirm = true } = props;
  const { t } = useTranslation(['common', 'member']);
  const [open, setOpen] = React.useState(false);

  const openDialog = () => {
    if (useConfirm) {
      setOpen(true);
    } else {
      callback();
    }
  };

  const confirm = () => {
    callback();
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
        <DialogTitle id='alert-dialog-title'>{t('member:importMember.cancelImportHeader')}</DialogTitle>
        <DialogActions sx={{ '& .MuiButton-text': { fontWeight: 600 } }}>
          <Button onClick={handleClose}>{t('common:button.no')}</Button>
          <Button onClick={confirm} autoFocus>
            {t('common:button.yes')}
          </Button>
        </DialogActions>
      </Dialog>
      <Button size='large' variant='outlined' onClick={() => openDialog()} sx={{ ml: 2 }} startIcon={<Close />}>
        {t('common:button.cancel')}
      </Button>
    </>
  );
};
